import React from 'react';

import { ProfileIcon } from '@ocx/ui-icons';
import { IconButton } from '@ocx/ui';
import { useGetNavigationActions } from '../../../../hooks/useGetNavigationActions';

export const ProfileButton: React.FC = () => {
  const { pushToProfile } = useGetNavigationActions();

  return (
    <IconButton onClick={pushToProfile} color="inherit">
      <ProfileIcon />
    </IconButton>
  );
};
